import e from "../schema/SchemaRailPanel.vue.js";
import t from "../schema/SchemaGutterToggle.vue.js";
import { Fragment as n, computed as r, createBlock as i, createCommentVNode as a, createElementBlock as o, createElementVNode as s, defineComponent as c, normalizeClass as l, openBlock as u, ref as d, renderList as f, resolveComponent as p, toDisplayString as m, unref as h, useId as g, withCtx as _ } from "vue";
//#region src/specification-extensions/ExtensionValue.vue?vue&type=script&setup=true&lang.ts
var v = ["id", "aria-hidden"], y = ["id"], b = { class: "font-code break-words whitespace-pre-wrap" }, x = /*@__PURE__*/ c({
	__name: "ExtensionValue",
	props: {
		name: {},
		value: {},
		depth: { default: 0 },
		arrayItem: {
			type: Boolean,
			default: !1
		},
		ancestors: { default: () => [] }
	},
	setup(c) {
		let x = g(), S = g(), C = d(c.depth === 0), w = r(() => c.ancestors.includes(c.value)), T = r(() => c.value === null || typeof c.value != "object" || w.value ? [] : Array.isArray(c.value) ? c.value.map((e, t) => [`[${t}]`, e]) : Object.entries(c.value)), E = r(() => T.value.length > 0), D = r(() => c.arrayItem && E.value ? Array.isArray(c.value) ? "[…]" : "{…}" : !c.arrayItem && !E.value ? `${c.name}:` : c.name), O = r(() => w.value ? "[Circular]" : typeof c.value == "string" ? JSON.stringify(c.value) : c.value !== null && typeof c.value == "object" ? Array.isArray(c.value) ? "[]" : "{}" : String(c.value));
		return (r, d) => {
			let g = p("ExtensionValue", !0);
			return u(), o("div", { class: l(["relative min-w-0 py-0.5", {
				"ps-8": c.depth === 0,
				"flex items-baseline gap-x-2": !c.arrayItem && !E.value
			}]) }, [s("dt", { class: l(c.arrayItem && !E.value ? "sr-only" : "relative flex min-h-5 min-w-0 flex-wrap items-baseline gap-x-2") }, [
				E.value ? (u(), i(h(t), {
					key: 0,
					class: "absolute start-[calc(0px_-_var(--schema-gutter,16px)_-_var(--schema-toggle-half,12px))] top-[0.5lh] -translate-y-1/2",
					fallbackLabel: c.name,
					nameId: h(x),
					open: C.value,
					panelId: h(S),
					panelRendered: C.value,
					onToggle: d[0] ||= (e) => C.value = !C.value
				}, null, 8, [
					"fallbackLabel",
					"nameId",
					"open",
					"panelId",
					"panelRendered"
				])) : a("", !0),
				!c.arrayItem || E.value ? (u(), o("span", {
					key: 1,
					id: c.arrayItem ? void 0 : h(x),
					"aria-hidden": c.arrayItem || void 0,
					class: "font-code min-w-0 font-medium break-words"
				}, m(D.value), 9, v)) : a("", !0),
				c.arrayItem ? (u(), o("span", {
					key: 2,
					id: h(x),
					class: "sr-only"
				}, "Array item " + m(c.name), 9, y)) : a("", !0)
			], 2), E.value && C.value ? (u(), i(h(e), {
				key: 0,
				id: h(S),
				as: "dd",
				class: "mt-0.5",
				depth: c.depth + 1
			}, {
				default: _(() => [s("dl", null, [(u(!0), o(n, null, f(T.value, ([e, t]) => (u(), i(g, {
					key: e,
					ancestors: [...c.ancestors, c.value],
					arrayItem: Array.isArray(c.value),
					depth: c.depth + 1,
					name: e,
					value: t
				}, null, 8, [
					"ancestors",
					"arrayItem",
					"depth",
					"name",
					"value"
				]))), 128))])]),
				_: 1
			}, 8, ["id", "depth"])) : E.value ? a("", !0) : (u(), o("dd", {
				key: 1,
				class: l(["text-c-2 min-w-0", { "flex-1": !c.arrayItem }])
			}, [s("code", b, m(O.value), 1)], 2))], 2);
		};
	}
});
//#endregion
export { x as default };

//# sourceMappingURL=ExtensionValue.vue.script.js.map